import styled, { css } from 'styled-components';
import { P } from 'components/Typography';
import { sizes } from 'style';
import { th } from 'style/theme';

export const StyledProductCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 280px;
  padding: 20px;
  border-radius: 6px;
  background-color: ${({ primaryColor }) => primaryColor};
  opacity: ${({ inView }) => (inView ? 1 : 0.75)};
  transition: opacity 200ms;

  @media ${sizes.tabletPortrait} {
    opacity: 0.75;
  }

  @media ${sizes.desktop} {
    min-width: 330px;
  }

  ::before {
    content: ' ';
    position: absolute;
    top: -40px;
    left: 50%;
    transform: translateX(-50%);
    width: 2px;
    height: 40px;
    background-color: ${th('colors.white')};

    @media ${sizes.extraLargeDesktop} {
      top: -60px;
      height: 60px;
    }
  }

  ::after {
    content: ' ';
    position: absolute;
    top: -45px;
    left: 50%;
    transform: translateX(-50%);
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${th('colors.white')};
    ${({ noGlow }) =>
      !noGlow &&
      css`
        box-shadow: 0 0 3px 2px #c3c3c3;
      `};
    opacity: 1;

    @media ${sizes.extraLargeDesktop} {
      top: -65px;
    }
  }

  > button {
    background-color: ${({ secondaryColor }) => secondaryColor};
    :hover {
      background-color: ${({ secondaryColor }) => secondaryColor};
    }
  }

  :hover {
    opacity: 1;
  }
`;

export const Title = styled.div`
  margin-bottom: 12px;
  font-size: 28px;
  font-family: ${th('fonts.headings')};
  font-weight: bold;
`;

export const Description = styled(P)`
  line-height: 1.5;
  margin-bottom: 20px;
`;
